var map = {
	"./1.png": "7f56",
	"./2.png": "56fd",
	"./3.png": "62f6",
	"./4.png": "3e72",
	"./5.png": "f662",
	"./Fake_Video-1.jpg": "7473",
	"./Fake_Video-2.jpg": "e6d6",
	"./Fake_Video-3.jpg": "68b1",
	"./Fake_Video-4.jpg": "a154",
	"./Fake_Video-5.jpg": "097f",
	"./Fake_Video-6.jpg": "fd5d",
	"./Fake_Video-7.jpg": "2611",
	"./Fake_Video-8.jpg": "0b0c",
	"./Fake_Video-9.jpg": "5be3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af69";